import { LinhaVenda, Setor } from '@shared/models';
import { Injectable } from "@angular/core";
import {
  Http,
  Headers,
  RequestMethod,
  ResponseContentType
} from "@angular/http";

import { State, City, Holiday } from "@shared/models";

import { ConfigService } from "@shared/utils/config.service";

import { BaseService } from "@core/services/base.service";

import { Observable } from "rxjs/Rx";

import { AcompanharLancamentoSetor } from '../pages/acompanhar-lancamento-setor/models'

import {
  ParametersExportBalance,
  ParametrosClientesPorVendedor,
  ParametrosHistoricoRecepcaoTransmissao,
  RetornoClientesPorVendedor,
  RetornoHistoricoRecepcaoTransmissao,
} from './clientes.interface'

// Add the RxJS Observable operators we need in this app.
import "../../../rxjs-operators";

@Injectable()
export class ClientesService extends BaseService {
  baseUrl: string = "";
  mockUrl = "http://localhost:3000"

  constructor(private http: Http, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  authorizedHeaders(): Headers {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return headers;
  }

  getComercios(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/clients/getTipoComercio`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getLinhas(): Observable<LinhaVenda[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/vendas/getLinhas`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVisaoCidade(parameters): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(`${this.baseUrl}/vendas/visaoPorCidade`, parameters, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getPeriodoVisaoCidade(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/parametros/getPeriodoVisaoPorCidade`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getStatus(): Observable<State[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/listarTodosPedidos`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getStates(idSetor): Observable<State[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/locations/states?setor=${idSetor}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCities(idState: number, idSetor): Observable<City[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/locations/cities?state=${idState}&setor=${idSetor}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCitiesWithSalesPerson(idState: number, idSetor, idSetorVendedor): Observable<City[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/locations/citiesWithSalesPerson?state=${idState}&setor=${idSetor}&setorVendedor=${idSetorVendedor}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getDistricts(idCity: number, idSetor): Observable<string[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/locations/districts?city=${idCity}&setor=${idSetor}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVendedores(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/vendedores/listarTodos", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getSetores(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/setor/listarTodos", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getTipoDebito(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/carteiraPedido/getTipoDebito", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getPortador(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/carteiraPedido/getPortador", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getIdSetor(cdfzs): Observable<number> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + `/vendedores/RetornaIdSetorComercialPorCdfzs?cdfzs=${cdfzs}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getDebitoEmAberto(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/carteiraPedido/getDebitoEmAberto", params, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCarteiraPedido(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/carteiraPedido/getCarteiraPedido", params, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getStatusVisita(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + "/statusVisita/listarTodos", { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  filterVisitasPorHistorico(params): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/listarHistorico", params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getVisita(IdCli, idSetor, idFiliall, dataPrevVisita): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/visits/GetVisita?IdCli=${IdCli}&idSetor=${idSetor}&idFilial=${idFiliall}&dataPrevVisita=${dataPrevVisita}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getListaClientesProximos(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/GetListaClientesProximos`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getSemana(data) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/GetSemana?dataParam=${data}&proxima=true`, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getProximaSemana() {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/GetProximaSemana`, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getClienteCnpj(Cnpj): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/clients/buscaCliente?Cnpj=${Cnpj}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getClienteSemMovimentacao(agentId, ufId, cityId, lastMov, codSetor, vendedorSelecionado): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    const params: any = {
      agentId
    };

    if (ufId !== null && ufId !== "null") params.ufId = ufId;
    if (cityId !== null && cityId !== "null") params.cityId = cityId;
    if (lastMov !== null && lastMov !== "null") params.lastMov = lastMov;
    if (codSetor !== null && codSetor !== "null") params.codSetor = codSetor;
    if (vendedorSelecionado !== null && vendedorSelecionado !== "null") params.vendedorSelecionado = vendedorSelecionado;

    return this.http
      .get(`${this.baseUrl}/visits/getMovimentacaoClienteByParam`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getEspelhoPedido(params): Observable<any> {
    let headers = new Headers();
    //passando pra apenas numero inteiro para fazer a busca corretamente.
    if(params.cnpj)
      params.cnpj = parseInt(params.cnpj.replace(/\D/g, ''));

    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");

    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/getEspelhoPedidos`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getReportPedidoConformeVenda(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/getReportPedidoConformeVenda`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getReportPedidoConformeFaturamento(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/getReportPedidoConformeFaturamento`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  convertBase64ToPdfAndSendReportEmail(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(`${this.baseUrl}/carteiraPedido/convertBase64ToPdfAndSendReportEmail`, params, {
        headers
      })
      .map(response => "")
      .catch(this.handleError);
  }

  getConsultaPedido(params): Observable<any> {
    let headers = new Headers();

    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");

    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/getConsultaPedido`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getConsultaPedidoComDataEmissaoPedido(params): Observable<any> {
    let headers = new Headers();

    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");

    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/getConsultaPedidoComDataEmissaoPedido`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  novoPedido(params): Observable<any> {
    let headers = new Headers();

    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");

    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/NovoPedido`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  buscarClienteVendedor(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(`${this.baseUrl}/clients/buscaClientePorVendedor`, params, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  saveRateio(PercLinhaDia, PercLinhaNoite, ValoresCli): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(
        this.baseUrl + "/vendas/realizarRateio ",
        {
          PercLinhaDia,
          PercLinhaNoite,
          ValoresCli
        },
        { headers }
      )
      .map(response => "")
      .catch(this.handleError);
  }

  editVisita(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/alterar", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  salvarVisitaSemPlanejamento(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/visits/incluir", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  getAlertasByCliente(idCliente, data) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/alertas/listarPorVisita?idCliente=${idCliente}&dataVisita=${data}`,
        {
          headers
        }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/alertas/incluir", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  excluirAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/alertas/excluir", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  consultarControleDeVisitas(params): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/listarControleVisita", params, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  saveVisita(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/incluirLista", params, { headers })
      .map(response => "")
      .catch(this.handleError);
  }

  saveVisitaReagendamento(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    console.log(params);
    return this.http
      .post(this.baseUrl + "/visits/incluirListaReagendamento", params, {
        headers
      })
      .map(response => "")
      .catch(this.handleError);
  }

  getScheduledVisits(agentId, weekStartDate, weekEndDate): Observable<any[]> {
    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(
        `${this.baseUrl}/visits/GetListaDiasdaSemana?agentId=${agentId}&dataInicial=${weekStartDate}&dataFinal=${weekEndDate}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getClienteById(id, trazerAlertas = true): Observable<string[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/clients/getInfo?idCliente=${id}&trazerAlertas=${trazerAlertas}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  transferirPlanejamento(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    return this.http.post(
      this.baseUrl + "/visits/transmitirPlanejamento",
      params,
      { headers, responseType: ResponseContentType.Blob }
    );
  }

  getFeriados(weekStartDate, weekEndDate): Observable<any[]> {
    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(
        `${this.baseUrl}/visits/getFeriado?dataInicio=${weekStartDate}&dataFim=${weekEndDate}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  imprimirPlanejamento(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Access-Control-Allow-Origin", `*`);

    let requestOptions = {
      method: RequestMethod.Post,
      responseType: ResponseContentType.Blob,
      headers: headers
    };

    return this.http.post(
      this.baseUrl + "/visits/imprimirPlanejamentoDinkToPDF",
      params,
      requestOptions
    );
  }

  getPrecos(): Observable<any[]> {
    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/listarTabelaPreco`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getMostruarioIdeal(idCli, descricaoLinha): Observable<any[]> {
    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(
        `${this.baseUrl}/vendas/getMostruarioIdeal?IdCli=${idCli}&descricaoLinha=${descricaoLinha}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCarteiraFutura(idCli): Observable<any[]> {
    let headers: Headers = this.authorizedHeaders();

    return this.http
      .get(`${this.baseUrl}/carteiraPedido/getCarteiraFutura?IdCli=${idCli}`, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getAcopanharPrevisaoSetor(mesInicio, mesFim): Observable<AcompanharLancamentoSetor[]> {
    const headers = this.authorizedHeaders();

    return this.http
      .get(
        `${this.baseUrl}/vendas/acompanharPrevisaoSetor?mesInicio=${mesInicio}&mesFim=${mesFim}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getAcopanharPrevisaoComSetor(mesInicio, mesFim, setorSelecionado): Observable<AcompanharLancamentoSetor[]> {
    const headers = this.authorizedHeaders();

    return this.http
      .get(
        `${this.baseUrl}/vendas/acompanharPrevisaoComSetor?mesInicio=${mesInicio}&mesFim=${mesFim}&setorSelecionado=${setorSelecionado}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getClientesPorVendedor(
    params: ParametrosClientesPorVendedor
  ): Observable<RetornoClientesPorVendedor[]> {
    const headers = this.authorizedHeaders();

    return this.http
      .post(
        `${this.baseUrl}/clients/clientesporvendedor`,
        params,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getHistoricoRecepcaoTransmissao(setor: Setor, regional: string, dtSelecionada: string, status: number)
  : Observable<RetornoHistoricoRecepcaoTransmissao[]> {
    const headers = this.authorizedHeaders();

    const params: any = {
      setor,
      regional,
      dtSelecionada,
      status
    };

    return this.http
      .post(
        `${this.baseUrl}/clients/getHistoricoRecepcaoTransmissao`,
        params,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  exportarClientesPorVendedor(
    params: ParametrosClientesPorVendedor
  ): Observable<any> {
    const headers = this.authorizedHeaders();

    return this.http
      .post(
        `${this.baseUrl}/clients/exportar`,
        params,
        {
          method: RequestMethod.Post,
          responseType: ResponseContentType.Blob,
          headers: headers
        }
      )
      //.map(response => response.blob())
      .catch(this.handleError);
  }

  exportBalance(params: ParametersExportBalance): Observable<any> {
    const headers = this.authorizedHeaders();

    return this.http
      .post(
        `${this.baseUrl}/clients/exportBalance`,
        params,
        {
          method: RequestMethod.Post,
          responseType: ResponseContentType.Blob,
          headers: headers
        }
      )
      //.map(response => response.blob())
      .catch(this.handleError);
  }

  getDebitoEmAbertoPorCNPJ(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(this.baseUrl + "/carteiraPedido/getDebitoEmAbertoPorCNPJ", params, {
        headers
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  saveAutorizacaoDigitacaoTRC(params) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
    .post(this.baseUrl + "/carteiraPedido/saveAutorizacaoDigitacaoTRC", params, {
      headers
    })
    .map(response => response.json())
    .catch(this.handleError);

  }

  getRelatorio(fzs, anoInicial, anoFinal, tcComercio, cidade, clienteSemMovimento, mesAnoInicial, mesAnoFinal, mesInicial, mesFinal, compMes ): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    const params: any = {
      fzs
    };

    params.fzs = fzs;
    params.anoInicial = anoInicial;
    params.anoFinal = anoFinal;
    params.tcComercio = tcComercio;
    params.cidade = cidade;
    params.clienteSemMovimento = clienteSemMovimento;
    params.mesAnoInicial = mesAnoInicial;
    params.mesAnoFinal = mesAnoFinal;
    params.mesInicial = mesInicial;
    params.mesFinal = mesFinal;
    params.compMes = compMes;

    // if (fzs !== null && fzs !== "null") params.ufId = ufId;
    // if (cityId !== null && cityId !== "null") params.cityId = cityId;
    // if (lastMov !== null && lastMov !== "null") params.lastMov = lastMov;
    // if (codSetor !== null && codSetor !== "null") params.codSetor = codSetor;
    // if (vendedorSelecionado !== null && vendedorSelecionado !== "null") params.vendedorSelecionado = vendedorSelecionado;

    return this.http
      .get(`${this.baseUrl}/visits/getRelatorio`, {
        headers,
        params
      })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCidades(fzs): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/getCidades?fzs=${fzs}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCidadeGrid(fzs, cidade): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(`${this.baseUrl}/visits/getCidadeGrid?fzs=${fzs}&cidade=${cidade}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  // exportRelVendasPorCidade(params: ParametersExportBalance): Observable<any> {
  exportRelVendasPorCidade(fzs, anoInicial, anoFinal, tcComercio, cidade, clienteSemMovimento, mesAnoInicial, mesAnoFinal, mesInicial, mesFinal, compMes  ): Observable<any> {
    const headers = this.authorizedHeaders();

    const params: any = {
      fzs
    };

    params.fzs = fzs;
    params.anoInicial = anoInicial;
    params.anoFinal = anoFinal;
    params.tcComercio = tcComercio;
    params.cidade = cidade;
    params.clienteSemMovimento = clienteSemMovimento;
    params.mesAnoInicial = mesAnoInicial;
    params.mesAnoFinal = mesAnoFinal;
    params.mesInicial = mesInicial;
    params.mesFinal = mesFinal;
    params.compMes = compMes;

    return this.http
      .post(
        `${this.baseUrl}/clients/exportRelVendasPorCidade`,
        params,
        {
          method: RequestMethod.Post,
          responseType: ResponseContentType.Blob,
          headers: headers
        }
      )
      //.map(response => response.blob())
      .catch(this.handleError);
  }

}
